// extracted by mini-css-extract-plugin
module.exports = {"container":"course-footer_container__3orGd","organization":"course-footer_organization__1XaGT","links":"course-footer_links__17_P5","link":"course-footer_link__EFTNw"};